import React, { useEffect, useRef, useState } from 'react';
import {
  DialogActions,
  DialogTitle,
  Paper,
  TextField,
  Typography
} from '@material-ui/core';
import Draggable from 'react-draggable';
import Button from 'components/Button/button';

import {
  LabelPrintWriteOffDialogContainer,
  PrintWriteOffDialogContent,
  PrintWriteOffBottomInfos,
  WriteOffNumberOfLabelsContainer
} from '../../styles';

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggableLabelPrintWriteOffDialog"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

export default function PrintQuantityDialog({
  open,
  onClose = () => {},
  onSubmit = () => {},
  labelItem
}) {
  const inputRef = useRef(null);
  const [qty, setQty] = useState('1'); 

  const notCleared = Number(labelItem?.notClearedCount) || 0;
  const cleared = Number(labelItem?.clearedCount) || 0;
  const totalInBatch = notCleared + cleared || 1;
  const maxAllowed = Math.max(1, notCleared);

  useEffect(() => {
    if (!open) return;

    setQty('1');

    const t = setTimeout(() => {
      const input = inputRef.current;
      if (input) {
        input.focus();
        input.setSelectionRange?.(0, input.value?.length ?? 0);
      }
    }, 300);

    return () => clearTimeout(t);
  }, [open, labelItem]);

  const handleConfirm = () => {
    const n = Number(String(qty || '').replace(/\D/g, '') || 0);
    if (!Number.isFinite(n) || n < 1) return;
    onSubmit(labelItem, n);
  };

  const handleChange = (e) => {
    const raw = String(e.target.value ?? '').replace(/\D/g, '');
    if (!raw) {
      setQty('');
      return;
    }
    const n = parseInt(raw, 10);
    if (Number.isNaN(n)) {
      setQty('');
      return;
    }
    const bounded = Math.max(1, Math.min(n, maxAllowed));
    setQty(String(bounded));
  };

  return (
    <LabelPrintWriteOffDialogContainer
      className="defaultModal"
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperComponent={PaperComponent}
    >
      <DialogTitle
        className="modalHeader lightBlue bold textCenter cursorMove"
        id="draggableLabelPrintWriteOffDialog"
        fullWidth
      >
        <Typography>IMPRESSÃO DE ETIQUETAS</Typography>
      </DialogTitle>

      <PrintWriteOffDialogContent>
        <PrintWriteOffBottomInfos>
          <span className="title">Deseja imprimir esta etiqueta?</span>

          <WriteOffNumberOfLabelsContainer>
            <span className="textAlignRight mr10">
              QTDE DE <br /> ETIQUETAS
            </span>

            <TextField
              id="printQuantity"
              inputRef={inputRef}
              className="textFieldSmall right childInputP0 childInputW100 childInputFontSize20"
              variant="outlined"
              fullWidth
              type="text"
              value={qty}
              inputProps={{
                inputMode: 'numeric',
                pattern: '[0-9]*',
                max: maxAllowed
              }}
              onChange={handleChange}
              onBlur={() => {
                if (qty === '' || Number(qty) < 1) setQty('1');
              }}
            />

            <span className="ml10">/{maxAllowed}</span>
          </WriteOffNumberOfLabelsContainer>
        </PrintWriteOffBottomInfos>
      </PrintWriteOffDialogContent>

      <DialogActions className="w100 justifyCenter">
        <Button
          className="defaultButton backButton"
          design="outlined"
          label="Não"
          onClick={onClose}
          style={{ outline: 0 }}
        />

        <Button
          className={`defaultButton ${!qty ? 'disabledButton' : 'submitButton'}`}
          design="outlined"
          label="Sim"
          onClick={handleConfirm}
          disabled={notCleared <= 0 || !qty}
          style={{ outline: 0 }}
        />
      </DialogActions>
    </LabelPrintWriteOffDialogContainer>
  );
}
